import React, { Component } from 'react';
import PropTypes from 'prop-types';

const BASE_CLASS_NAME = 'PopoverAnchor';
export default class PopoverAnchor extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    };

    newPopoverAnchorRef = React.createRef();

    getAnchorEl = () => (this.newPopoverAnchorRef && this.newPopoverAnchorRef.current) || null;

    getRefWidth = () =>
        this.newPopoverAnchorRef && this.newPopoverAnchorRef.current && this.newPopoverAnchorRef.current.clientWidth;

    render() {
        return (
            <div ref={this.newPopoverAnchorRef} className={BASE_CLASS_NAME}>
                {React.Children.map(this.props.children, (child) =>
                    React.cloneElement(child, {
                        getAnchorEl: this.getAnchorEl,
                        getRefWidth: this.getRefWidth,
                    }),
                )}
            </div>
        );
    }
}
